import { required, array, obj } from 'AppReact/schema';

export const badgeRule = {
  name: required('string'),
  rule_id: required('integer'),
  input_type: required('string'),
  description: required('string'),
  format: required('string'),
  sort_index: required('integer')
}

export const badgeType = {
  id: required('integer'),
  type: required('string'),
  rules: obj({
    required: array(obj(badgeRule)),
    optional: array(obj(badgeRule)),
  })
};